/* 🤖 this file was generated by svg-to-ts */
export const siriusMoon: {
  name: 'moon';
  data: string;
} = {
  name: 'moon',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.225 3.155a.75.75 0 0 1 .19.732 7.866 7.866 0 0 0 9.698 9.697l.203.722.722.201A9.376 9.376 0 1 1 9.493 2.962a.75.75 0 0 1 .732.193Zm8.927 12.149A9.367 9.367 0 0 1 8.696 4.848a7.875 7.875 0 1 0 10.456 10.456Z" fill="currentColor"/></svg>`
};
